import { Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';
import ICON_WARNING from '@/assets/common/error.png';
import ICON_CHAT from '@/assets/cs/icon_chat.png';
import ICON_TEL from '@/assets/cs/icon_tel.png';
import { updateCs } from '@/store/modules/cs';
import { useAppDispatch } from '@/hooks/useReduxHooks';
type Props = {
  isOpen: boolean;
  desc: string;
  onClose: () => void;
};

function PaymentCancelErrorModal({ isOpen, desc, onClose }: Props) {
  const dispatch = useAppDispatch();

  const onOpenChatModal = () => {
    dispatch(
      updateCs({
        isOpenCsModal: true,
        isOpenChat: true,
        chatId: null,
        isHiddenInquiryButtons: true,
      }),
    );
    onClose();
  };

  return (
    <Modal isOpen={isOpen} hasBackdrop>
      <Modal.Header>
        <Title>
          <IconWarning src={ICON_WARNING} alt='' />
          결제 직접 취소 불가
        </Title>
      </Modal.Header>
      <Content>{desc}</Content>
      <ContactSection>
        <ContactUs>
          <Wrapper>
            <ContactIcon src={ICON_CHAT} alt='' />
            채팅 문의하기
          </Wrapper>
          <GoToChatButton
            onClick={() => {
              onOpenChatModal();
            }}
          >
            바로가기 <Icon.ChevronRight size={16} fillColor='#111111' />
          </GoToChatButton>
        </ContactUs>
        <ContactUs>
          <Wrapper>
            <ContactIcon src={ICON_TEL} alt='' />
            전화 문의하기
          </Wrapper>
          <Tellus>02-6275-8011</Tellus>
        </ContactUs>
      </ContactSection>
      <Modal.Footer footerStyle={{ marginTop: '40px' }}>
        <Button onClick={onClose}>닫기</Button>
      </Modal.Footer>
    </Modal>
  );
}

const Title = styled.h4`
  display: flex;
  align-items: center;
  color: var(--Mono-100, #030303);

  /* header/24px */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
  margin-bottom: 16px;
`;

const IconWarning = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 8px;
  margin-bottom: 4px;
`;

const Content = styled.p`
  width: 436px;
  margin-bottom: 40px;
  color: var(--Mono-65, #5f6165);

  /* WebBody/16_MD */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
  white-space: pre;
`;
const ContactSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ContactUs = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 15px 20px;
  border-radius: 12px;

  background: #f5f6f7;
  color: #000;

  /* WebBody/16_MD */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const GoToChatButton = styled.button`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0;
`;

const ContactIcon = styled.img`
  width: 42px;
  height: 42px;
  margin-right: 12px;
`;

const Tellus = styled.div`
  display: flex;
  width: 130px;
  height: 36px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 120px;
  background: #e9f0fe;
  color: var(--Blue-80, #5089f8);

  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const Button = styled.button`
  display: flex;
  height: 52px;
  padding: 14px 0px;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-radius: 8px;
  background: var(--Mono-10, #e5e6e8);
  color: var(--Mono-80, #3a3b3e);
  text-align: center;

  /* WebTitle/16_SB */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
`;

export default PaymentCancelErrorModal;
